import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { GlobalReport } from "@prisma/client";

const enableGlobalReport = async (frequency: string) => {
  return privateAxios.put<GlobalReport>(`/global-report`, {
    frequency,
  });
};

export const useEnableGlobalReportMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: enableGlobalReport,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["global-report"] });
    },
  });
};

const disableGlobalReport = async () => {
  return privateAxios.post<GlobalReport>(`/global-report/disable`);
};

export const useDisableGlobalReportMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disableGlobalReport,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["global-report"] });
    },
  });
};
